import React from 'react';
import { useReactiveVar } from '@apollo/client';
import { useRouterState } from 'app/hooks/useRouterState';

import { selectedPeriodVar } from 'app/apollo/reaction';
import { MenuSkeletonPage } from 'app/components/Skeletons/MenuPageSkeletons/menu.skeleton';
import MenuDishesProvider from 'app/containers/MenuDishesProvider';

import BR1258OpenBasketButton from './newMenu/BR1258OpenBasketButton/BR1258OpenBasketButton';
import MenuCategoryListAdapter from './newMenu/MenuCategoryListV2';
import styles from './mobile-menu-skeleton.module.scss';

function NewMobileMenuContent({
    setDishesUpdatingState,
    isBasketProcessing = false,
    isFiltersSelected,
    openBasket,
    ...rest
}) {
    const [routerState] = useRouterState();
    const { history } = routerState;
    const selectedPeriod = useReactiveVar(selectedPeriodVar);

    const handleOpenDishDetails = (dish) => {
        if (!dish?.id) return;
        history.push(`/dish/${dish.id}/`);
    };

    if (!isFiltersSelected || (selectedPeriod && isBasketProcessing)) {
        return <MenuSkeletonPage />;
    }

    return (
        <div className={styles.mobileMenuSkeleton}>
            <MenuDishesProvider
                wrapper="NewMobileMenu => renderDishes"
                setDishesUpdatingState={setDishesUpdatingState}
                fetchPolicy="network-only"
                render={(menuDishesProps) => (
                    <div className={styles.mobileMenuSkeletonLegacyContainer}>
                        <MenuCategoryListAdapter
                            {...menuDishesProps}
                            openDishDetails={handleOpenDishDetails}
                            setDishesUpdatingState={setDishesUpdatingState}
                            openBasket={openBasket}
                            {...rest}
                        />
                        {/* {!selectedFilters?.isSelectedDefaultFilters && (
                            <div className={styles.mobileMenuSkeletonReset}>
                                <UIButton
                                    colorType="secondary"
                                    onClick={handleResetFilters}
                                >
                                    Посмотреть все блюда
                                </UIButton>
                            </div>
                        )} */}
                    </div>
                )}
            />
            <BR1258OpenBasketButton
                onClick={openBasket}
            />
        </div>
    );
}

export default NewMobileMenuContent;
